import { api } from "@/lib/api";
import type { Identity } from "./types";

export const authApi = {
  /** 401 when signed out, which `useIdentity` treats as an answer rather than a
   *  failure — being signed out is the most common state, not an error. */
  me: () => api.get<Identity>("/auth/me"),
};

export const authKeys = {
  me: ["auth", "me"] as const,
};

/**
 * Sign-in and sign-out are **browser navigations, not fetches**.
 *
 * `/auth/login` answers with a redirect to Microsoft, and `/auth/logout` with a
 * 303 back to the app. `fetch` would follow both and hand back the SPA's own
 * index.html, which there is nothing useful to do with. A link and a form let
 * the browser do what these responses are actually asking it to do — and it
 * keeps `lib/api.ts` the only place that calls `fetch`.
 */
export const LOGIN_URL = "/api/v1/auth/login";
export const LOGOUT_URL = "/api/v1/auth/logout";
